
import { Vue, Component } from "vue-property-decorator";
@Component({
  name: "withdrawal",
})
export default class withdrawal extends Vue {
  private tableData: Array<any> = [];
  private pageNo = 1;
  private pageSize = 10;
  private form = {};
  
  data() {
        return {
          options1: [{
            value1: '选项1',
            label1: '成功'
          }, {
            value1: '选项2',
            label1: '失败'
          }],
          value1: '',
		  options2: [{
		    value2: '选项1',
		    label2: '支付宝'
		  }, {
		    value2: '选项2',
		    label2: '微信'
		  }],
		  value2: ''
        }
    }

  private get pagedTableData() {
    return this.tableData.filter(
      (v, i) =>
        i >= (this.pageNo - 1) * this.pageSize &&
        i <= this.pageNo * this.pageSize - 1
    );
  }

  private mounted() {
    
	this.getWithdrawalList(1);
  }
  
  private getWithdrawalList(num:number){
	  
	  let datas = [];
	  this.pageNo = num;
	  let pageNum = this.pageNo;
	  let pageSize = 10;
	  let type = 2;
	  let paramter = {
	  		pageNum,
	  		pageSize,
			type
	    };
	  this.$http.get("system/manage/cash/out/record", {params:paramter}).then((res: any) => {
	  	datas = res.data.data.data.data;
	  	this.pageNo = num;
	  	this.pageSize = res.data.data.data.pageSize;
	  	this.tableData = datas;
		this.tableData = this.tableData.map((item,index)=>{
			
			if(item.cashOutType == 1) {
				item.cashOutType = '微信';
			} else if(item.cashOutType == 2) {
				item.cashOutType = '支付宝';
			} else if(item.cashOutType == 3) {
				item.cashOutType = '银行卡';
			} 
			if(item.status == 0) {
				item.statusStr = '申请中';
			} else if(item.status == 1) {
				item.statusStr = '提现中';
			} else if(item.status == 2) {
				item.statusStr = '已完成';
			}
			return item;
		});
		
		this.tableData = this.tableData.filter(function(item){
			
			return item.cashOut < 0;
		})
		
	  });
  }
  
  private agree(item){
  	  
  	  let record = item;
  	  let remark;
  	  let approveRemark;
  	  if(record.remark == null) {
  	  		  remark = '';
  	  } else {
  	  		  
  	  		  remark = record.remark;
  	  }
  	  if(record.approveRemark == null) {
  	  		  approveRemark = '';
  	  } else {
  	  		  
  	  		  approveRemark = record.approveRemark;
  	  }
  	  
  	  let paramter = {
  	  	  id:record.id,
  	  		  remark:remark,
  	  		  approveRemark:approveRemark,
  	  		  approveType:1
  	  };
  	  this.$http.post("system/manage/accept/cash/out", paramter).then((res: any) => {
		  
		  let code = res.data.code;
		  let msg = res.data.msg;
		  if(code == 200) {
		  	window.location.reload();
		  	this.$message({
		  	    message: msg,
		  	    type: 'success'
		  	});
		  }
  	  });
  }

  private handleSizeChange(val: number) {
    console.log(`每页 ${val} 条`);
    this.pageSize = val;
    this.pageNo = 1;
  }

  private handleCurrentChange(val: number) {
    console.log(`当前页: ${val}`);
    this.pageNo = val;
	this.getWithdrawalList(this.pageNo);
  }
  private balanceStateChange(value) {
	  
	  // 余额权限
	  console.log(value);
  }
  private userStateChange(value){
	  
	  // 评论权限
    console.log(value);
  }
  private onSubmit() {
    console.log(this.form);
  }
  private handleBalance(index,row){
	  
	  console.log(row);
	  this.$router.push('/User/withdrawalHandle/?id='+row.id);
  }
  private handleYESDetail(index,row){
	  
	  let item = row;
	  if(item.status == 0 || item.status == 1){
	    		  
	    this.agree(item);
	  }
  }
}
